export const environment = {
  production: true,
  version: '2.0.23',
  // socketApiUrl: 'wss://acl-socket-server-vm.centralus.cloudapp.azure.com',  // URL of Production Socket API  
  socketApiUrl: 'wss://acl-web-pub-sub.webpubsub.azure.com',  // URL of development API Socket Server 
  socketHttpApiUrl: 'https://pubsub.iplayacl.com', // URL of development HTTP API Socket Server   
  apiUrl: 'https://api.iplayacl.com',  // URL of Production API  
};
